import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backdrop: {
            backdropFilter: "blur(5px)",
            top: 104,
            left: 284,
        },
        discoverBenchmarkBtn: {
            height: theme.spacing(2),
            padding: 0,
            borderRadius: 0,
            minWidth: "auto",
            color: theme.palette.secondary.main,
            borderBottom: `1px solid ${theme.palette.secondary.main}`,
        },
        headerInner: {
            paddingBottom: theme.spacing(3),
        },
        mainContainer: {
            padding: theme.spacing(2),
        },
        pageDescription: {
            fontSize: 16,
            color: theme.palette.secondary.main,
            marginBottom: theme.spacing(2),
        },
        contentWrapper: {
            display: "flex",
            gap: theme.spacing(2),
            [theme.breakpoints.down("md")]: {
                display: "block",
            },
        },
        chartWrapper: {
            flex: 1,
            overflow: "hidden",
            padding: theme.spacing(0, 8),
            [theme.breakpoints.down("xl")]: {
                padding: theme.spacing(0),
            },
            [theme.breakpoints.down("md")]: {
                width: "100%",
            },
        },
        filtersWrapper: {
            width: 400,
            [theme.breakpoints.down("wd")]: {
                width: 326,
            },
            [theme.breakpoints.down("lg")]: {
                width: 243,
            },
            [theme.breakpoints.down("md")]: {
                width: "100%",
            },
        },
        paginationStyled: {
            marginTop: "auto",
            "& .MuiPagination-ul": {
                padding: theme.spacing(1, 0, 1, 0),
                justifyContent: "center",
            },
            "& .MuiPaginationItem-root": {
                color: theme.palette.text.primary,
                fontSize: "12px",
            },
            "& .Mui-selected": {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.common.white,
            },
        },
        modalBackdrop: {
            top: "104px",
            left: "284px",
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.15)",
        },
    })
);

export default useStyles;
